import './UnderlyingStructureSection.scss'

const STAGES = ['Define', 'Own', 'Enlist', 'Resolve', 'Reinforce']

const UnderlyingStructureSection = () => (
  <section className="lnn-section lnn-section--alt lnn-underlyingSection">
    <div className="lnn-shell" data-reveal="up">
      <div className="lnn-underlyingSection__layout">
        <div className="lnn-underlyingSection__head">
          <h2>The Underlying Structure</h2>
          <p>Critical directives move through stages:</p>
        </div>

        <div className="lnn-underlyingSection__flow">
          <div className="lnn-underlyingSection__stages">
            {STAGES.map((stage) => (
              <div key={stage} className="lnn-underlyingSection__stage">
                {stage}
              </div>
            ))}
          </div>
        </div>

        <div className="lnn-underlyingSection__closing">
          <p>At each stage, interpretation can shift.</p>
          <p>When that shift is not visible, execution risk increases.</p>
        </div>
      </div>
    </div>
  </section>
)

export default UnderlyingStructureSection
